import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';

class WarningModal extends Component {
  constructor(props) {
    super(props);
    const { translate } = props;
    this.modalAction = translate('modal.title.attention');
    this.modalBody = translate('modal.message.select_one_file');
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  render() {
    const {
      isOpenWarnModal, mainText, subText, translate
    } = this.props;
    return (
      <Modal open={isOpenWarnModal} onClose={this.closeModal}>
        <div className="modal_popup_wrap">
          <div className="modal_popup_box">
            <div className="modal_popup">
              <h2 className="title">{this.modalAction}</h2>
              {
                mainText ? (
                  <p className="text">{mainText}</p>
                ) : (
                  <p className="text">{this.modalBody}</p>
                )
              }
              {
                subText
                  && <p className="small_text">{subText}</p>
              }
              <div className="button_wrap">
                <a
                  className="center_button"
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default WarningModal;
